import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, CalendarDays, Mail } from 'lucide-react';
import personalData from '../../data/personal';

const Contact = () => {
  return (
    <section id="contact" className="section-padding bg-[#f7f8fb]">
      <div className="container-wrapper">
        <motion.div
          className="mx-auto max-w-4xl text-center"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, ease: [0.19, 1, 0.22, 1] }}
        >
          <p className="section-label mb-4">Get started</p>
          <h2 className="text-4xl font-black leading-tight tracking-normal text-[#191922] sm:text-5xl md:text-6xl">
            Tell me what you want to build.
          </h2>
          <p className="mx-auto mt-6 max-w-2xl text-base leading-8 text-slate-600">
            Send the workflow, product idea, or operational problem. I will help turn it into a
            practical build plan and the first version your team can actually use.
          </p>

          <div className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <a
              href={personalData.calendly}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary group"
            >
              <CalendarDays className="h-4 w-4" />
              Book a 1:1 call
              <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
            </a>
            <a
              href={`mailto:${personalData.email}?subject=Project%20inquiry`}
              className="btn-secondary"
            >
              <Mail className="h-4 w-4" />
              Email Josh
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Contact;
